export class SubSystem {
    id: string;
    fullname: string;
    code: string
    description: string;
    tenantCount: number;
    status: number;
}
